import { useRouter } from 'next/router';

import { isTruthy } from '~/src/common/utils/guards';
import {
  GetCategories200,
  GetDetailBySlug200BreadcrumbsItem,
} from '~/src/queries/api-ecom/generated/api-ecom.schemas';
import { CatalogContentLinkQueryParams } from '~/src/screens/CatalogContent/ContentScreen/types';

const useBreadcrumbs = (
  categories?: GetCategories200,
  defaultValue?: GetDetailBySlug200BreadcrumbsItem[],
) => {
  const {
    query: { subcategory, category, categorySlug },
  } = useRouter<CatalogContentLinkQueryParams>();

  // L'accueil a un 'categorySlug' de '' (pathname = /)
  const isHome =
    !categorySlug ||
    categories?.items.find(
      cat => cat.tags?.includes('Home') && category?.trim() === cat.name.trim(),
    );

  const categoriesBreadcrumbs = subcategory
    ? [!isHome ? category : null, subcategory].filter(isTruthy).map(bc => {
        const cat = categories?.items.find(c => c.name.trim() === bc.trim());

        return {
          id: cat?.id,
          name: cat?.name,
          slug: cat?.slug,
          enabled: Boolean(cat?.name && cat?.slug),
        };
      })
    : defaultValue ?? [];

  return categoriesBreadcrumbs;
};

export default useBreadcrumbs;
